import React, { useRef, useEffect, useState } from 'react';

import logo from './logo.svg';
import './App.css';
import Landing from './views/landing/Landing';
import Claims from './views/claims/Claims'
import About from './views/about/About'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
const TITLE = 'Collectibulls'

function App() {

  useEffect(() => {
    document.title = TITLE
  }, []);
 
  return (
    <Router>
    <div>
      <title>{ TITLE }</title>
      {/* A <Switch> looks through its children <Route>s and
          renders the first one that matches the current URL. */}
      <Switch>
      <Route path="/claim">
          <Claims />
        </Route>
        <Route path="/about">
          <About />
        </Route>
        <Route path="/">
          <Landing />
        </Route>
      </Switch>
    </div>
  </Router>
  );
}

export default App;
